export enum Tabs {
  ConfirmationPending = "confirmationPending",
  ConfirmationSent = "confirmationMailSent",
  Confirmed = "confirmed",
  All = "all",
}
